export { default } from './SellerDetails';